;(function($, undefined){

    var previewTypes = {
        fade: function($contentPreview){
            var $content = $contentPreview.children('.content');
            var $showMore = $contentPreview.next('.showMore');
            $showMore.on('click', function(){
                $contentPreview.removeClass('collapsed').height($content.height());
                $showMore.hide(200, function(){$showMore.remove();});
            });
            // If there's not enough content to fill the preview area,
            // auto-trigger the preview to kill it
            if ($contentPreview.height() > $content.height()) {
                $showMore.trigger('click');
            }
        },
        importantFirst: function($contentPreview){
            if($contentPreview.find('.lessImportant').length){
                $contentPreview.next('.showMore').on('click', function(){
                    $contentPreview.find('.lessImportant').slideDown();
                    $(this).hide(200, function(){$(this).remove();});
                });
            }else{
                $contentPreview.next('.showMore').remove();
            }
        }
    };

    var rnn = window.rnn;

    // Initialise the user
    function initialiseShowMore() {
        $('.contentPreview').each(function(){
            var $contentPreview = $(this);
            var previewType = $contentPreview.data('preview').type;
            if (previewTypes[previewType]) {
                previewTypes[previewType]($contentPreview);
            }
        });
    }

    rnn.modules.register("showMore", {
        init: initialiseShowMore
    });

})(jQuery);
